module.exports = __webpack_public_path__ + "img/bed.c8927dc3.svg";